import React from "react";
import {Panel} from "react-bootstrap";
import Component from "../../components/AscComponent";
import SetBreadCrumb from "../Elements/AscElements/SetBreadCrumb";


export default class Summary extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            show: false,
            eval_flag: false,
        };
    }

    componentDidMount = async () => {
        await this.getCompanyControlByCompanyId("CALL_EVAL", "CALL_EVAL_OPTION");
    }

    panelOnClick = (path) => {
        this.props.historyPush({
            pathname: path,
        });
    };

    getCompanyControlByCompanyId = async (function_id, parameter_id) => {
        const company_id = this.props.userInfo.company_id;

        try {
            const result = await this.ascAxios('post', `${this.reactContainerPath}/getCompanyControlCallEvalByCompanyId`, {
                company_id,
                function_id,
                parameter_id
            });

            let flag = result.data && result.data.parameter_value === "Y" ? true : false;

            this.setState({
                eval_flag: flag
            });
        } catch (err) {
            console.error(err);
            this.showErrorObjectMesssage(err);
        }
    }


    render() {
        const chUsedSummaryPermission = this.getPermission("ChUsedSummary", "Summary");
        const monitoringSummaryPermission = this.getPermission("MonitoringSummary", "Summary");
        const monitoringPermission = this.getPermission("Monitoring");
        const callCountSummaryPermission = this.getPermission("CallCountSummary", "Summary");
        const waitCallSummaryPermission = this.getPermission("WaitCallSummary", "Summary");
        const callAnalysisSummaryBasePermission = this.getPermission("CallAnalysisSummary", "Summary");

        const isChUsedSummaryVisible = !!(chUsedSummaryPermission && chUsedSummaryPermission.read);
        const isCallCountSummaryVisible = !!(
            callCountSummaryPermission && callCountSummaryPermission.read
        );
        const isWaitCallSummaryVisible = !!(
            waitCallSummaryPermission && waitCallSummaryPermission.read
        );

        const isMonitoringSummaryVisible = !!(
            monitoringSummaryPermission &&
            monitoringSummaryPermission.read &&
            monitoringPermission &&
            monitoringPermission.read
        );

        const isCallAnalysisSummaryVisible =
            callAnalysisSummaryBasePermission &&
            callAnalysisSummaryBasePermission.read &&
            (callAnalysisSummaryBasePermission.scope_code === "system" || this.state.eval_flag);

        const hasAnyVisiblePanel =
            isChUsedSummaryVisible ||
            isMonitoringSummaryVisible ||
            isCallCountSummaryVisible ||
            isWaitCallSummaryVisible ||
            isCallAnalysisSummaryVisible;

        return (
            <React.Fragment>
                <SetBreadCrumb displayItems={[{ name: this.props.langText.Body.Summary }]} />
                {!hasAnyVisiblePanel && (
                    <div className="no-readable-panels-message text-danger">
                        {this.props.langText.Message.NoVisiblePanelByAuth}
                    </div>
                )}
                <div className="summary-panels">
                    {isChUsedSummaryVisible &&
                        <Panel
                            bsStyle="info"
                            bsSize="large"
                            className="summary-select"
                            onClick={() => this.panelOnClick("Summary/ChUsedSummary")}
                        >
                            <Panel.Heading>
                                <Panel.Title componentClass="h1">
                                    {this.props.langText.Body.ChUsedSummary}
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body className="body-summary-select">
                                {this.props.langText.Body.ChUsedSummaryDescription}
                            </Panel.Body>
                        </Panel>
                    }

                    {isMonitoringSummaryVisible &&
                        <Panel
                            bsStyle="info"
                            bsSize="large"
                            className="summary-select"
                            onClick={() => this.panelOnClick("Summary/MonitoringSummary")}
                        >
                            <Panel.Heading>
                                <Panel.Title componentClass="h1">
                                    {this.props.langText.Body.MonitoringSummary}
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body className="body-summary-select">
                                {this.props.langText.Body.MonitoringSummaryDescription}
                            </Panel.Body>
                        </Panel>
                    }

                    {isCallCountSummaryVisible &&
                        <Panel
                            bsStyle="info"
                            bsSize="large"
                            className="summary-select"
                            onClick={() => this.panelOnClick("Summary/CallCountSummary")}
                        >
                            <Panel.Heading>
                                <Panel.Title componentClass="h1">
                                    {this.props.langText.Body.CallCountSummary}
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body className="body-summary-select">
                                {this.props.langText.Body.CallCountSummaryDescription}
                            </Panel.Body>
                        </Panel>
                    }
                    {isWaitCallSummaryVisible &&
                        <Panel
                            bsStyle="info"
                            bsSize="large"
                            className="summary-select"
                            onClick={() => this.panelOnClick("Summary/WaitCallSummary")}
                        >
                            <Panel.Heading>
                                <Panel.Title componentClass="h1">
                                    {this.props.langText.Body.WaitCallSummary}
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body className="body-summary-select">
                                {this.props.langText.Body.WaitCallSummaryDescription}
                            </Panel.Body>
                        </Panel>
                    }
                    {isCallAnalysisSummaryVisible &&
                        <Panel
                            bsStyle="info"
                            bsSize="large"
                            className="summary-select"
                            onClick={() => this.panelOnClick("Summary/CallAnalysisSummary")}
                        >
                            <Panel.Heading>
                                <Panel.Title componentClass="h1">
                                    {this.props.langText.Body.CallAnalysisSummary}
                                </Panel.Title>
                            </Panel.Heading>
                            <Panel.Body className="body-summary-select">
                                {this.props.langText.Body.CallAnalysisSummaryDescription}
                            </Panel.Body>
                        </Panel>
                    }
                </div>
            </React.Fragment>
        );
    }
}
